import React from 'react';

import { Paragraph, Text } from 'components/core/Typography';

// importing the styles from the facility card and the stacked units component
// to make sure the loading card looks the same as the facility card
import './NewFacilityCard.scss';
import '../../unit/StackedUnits/NewStackedUnits.scss';
import './LoadingFacilityCard.scss';

export function LoadingFacilityCard() {
	return (
		<div className="loading-facility-card new-facility-card">
			<div className="facility-head">
				<div className="facility-image" />
				<div className="facility-details">
					<div className="facility-name-details">
						<div className="facility-name" />
						<div className="facility-details-icon">...</div>
					</div>
					<div className="facility-location" />
					<div className="call-n-reviews">
						<div className="facility-phone" />
						<div className="facility-rating" />
					</div>
				</div>
			</div>
			<div className="new-stacked-units loading-stacked-units">
				<div className="unit-container">
					<div className="unit" />
					<div className="unit-price" />
				</div>
				<div className="unit-container">
					<div className="unit" />
					<div className="unit-price" />
				</div>
				<div className="unit-container">
					<div className="unit" />
					<div className="unit-price" />
				</div>
			</div>
			<div className="compare-units">
				{/* Adding this so the loading card covers the same height as the facility card */}
				<Paragraph
					className="unit-comparision"
					size="smallMedium"
					weight="medium"
					color="lightGray"
					last
				>
					Compare all{' '}
					<Text
						size="smallMedium"
						weight="extraBold"
						color="lightGray"
					>
						XX units
					</Text>{' '}
					at this facility X
				</Paragraph>
			</div>
		</div>
	);
}

export default LoadingFacilityCard;
